import { render, staticRenderFns } from "./FolderCard.vue?vue&type=template&id=48d7d6d1&"
import script from "./FolderCard.vue?vue&type=script&lang=js&"
export * from "./FolderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports